import { SessionChange, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { PROMOTIONS_NAMESPACE } from '../store/modules/promotions/promotions.store.js';
import { store } from '../store/index.js';

var promotions = namespace(PROMOTIONS_NAMESPACE);
/**
 * Mixin responsible for fetching and providing landing pages data
 */
var LandingPageMixin = /** @class */ (function (_super) {
    __extends(LandingPageMixin, _super);
    function LandingPageMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'landing';
        _this.isLoading = false;
        return _this;
    }
    LandingPageMixin.prototype.fetchData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var language, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.isLoading = true;
                        language = this.magicConfig.language;
                        return [4 /*yield*/, this.fetchEntries({
                                type: this.type,
                                lang: language,
                                mobile: this.magicConfig.mobile,
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        e_1 = _a.sent();
                        this.__handleDataError(e_1);
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emitted when there was an error loading promotions.
     * Provides error message
     */
    LandingPageMixin.prototype.__handleDataError = function (error) {
        return error;
    };
    __decorate([
        promotions.Getter('entries'),
        __metadata("design:type", void 0)
    ], LandingPageMixin.prototype, "landingPages", void 0);
    __decorate([
        promotions.Action('fetchEntries'),
        __metadata("design:type", Object)
    ], LandingPageMixin.prototype, "fetchEntries", void 0);
    __decorate([
        promotions.Action('refreshEntries'),
        __metadata("design:type", Object)
    ], LandingPageMixin.prototype, "refreshEntries", void 0);
    __decorate([
        Watch('magicConfig.language', { immediate: true }),
        SessionChange(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LandingPageMixin.prototype, "fetchData", null);
    __decorate([
        Emit('error'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], LandingPageMixin.prototype, "__handleDataError", null);
    LandingPageMixin = __decorate([
        Component({
            store: store,
        })
    ], LandingPageMixin);
    return LandingPageMixin;
}(Mixins(MagicConfigMixin)));

export { LandingPageMixin };
